const appUrls = require('../constants/app-urls');
const { EDGE_LEGACY_VERSION } = require('../constants/browsers');
const { DEFAULT_LOCALE, blogLocales } = require('../constants/i18n');

const getBlogURL = (locale) => {
  const domain = blogLocales.includes(locale) ? `${locale}.` : '';
  return `https://${domain}blog.ecosia.org`;
};

exports.getBlogURL = getBlogURL;

exports.getFinancialReportURL = (locale) => {
  const domain = blogLocales.includes(locale) ? locale : DEFAULT_LOCALE;
  return `https://ecosia.co/finreports${domain}`;
};

exports.getAppOrExtensionUrl = ({
  os = '',
  browser = '',
  version,
  origin,
  locale = DEFAULT_LOCALE,
  referrerAttributes = {},
}) => {
  switch (os.toLowerCase()) {
    case 'ios': {
      return appUrls.APP_STORE;
    }
    case 'android': {
      const url = new URL(appUrls.PLAY_STORE);
      url.searchParams.set('hl', locale);
      if (['tt', 'utm_campaign', 'utm_content'].some((attribute) => referrerAttributes[attribute])) {
        const referrer = new URLSearchParams(referrerAttributes).toString();
        url.searchParams.set('referrer', encodeURIComponent(referrer));
      } else if (origin) {
        url.searchParams.set('referrer', origin);
      }
      return url.toString();
    }
    default:
      // do nothing
  }

  switch (browser.toLowerCase()) {
    case 'brave':
    case 'chrome':
      return appUrls.CHROME_EXTENSION;
    case 'firefox':
      return appUrls.FIREFOX_EXTENSION;
    case 'edge':
      // Edge uses chromium as base starting with version > 18
      return parseInt(version, 10) > EDGE_LEGACY_VERSION ?
        appUrls.EDGE_EXTENSION :
        appUrls.EDGE_INSTALL_INSTRUCTIONS;
    case 'opera':
      return appUrls.OPERA_ON_DESKTOP;
    case 'safari':
      return appUrls.SAFARI_ON_DESKTOP;
    case 'vivaldi':
      return appUrls.VIVALDI_ON_DESKTOP;
    default:
      return appUrls.OPEN_SEARCH;
  }
};

exports.getDevUrl = (port) => `http://local.ecosia.org${port ? `:${port}` : ''}`;

exports.getBcorpUrl = () => 'https://www.bcorporation.net/find-a-b-corp/company/ecosia-gmbh/';

exports.getBingMapsSearchUrl = (query) => `https://www.bing.com/maps?q=${query}`;

exports.getGoogleMapsSearchUrl = (query) => `https://google.com/maps/search/${query}`;

exports.getGoogleMapsDirectionUrl = (query) => `https://google.com/maps/dir/?api=1&destination=${query}`;

exports.getHostname = (url) => {
  try {
    return new URL(url).hostname;
  } catch (err) {
    return '';
  }
};

exports.getProjectsUrl = (locale) => {
  let subpath = 'where-does-ecosia-plant-trees';
  if (locale === 'de') {
    subpath = 'projekte';
  } else if (locale === 'fr') {
    subpath = 'projets';
  }
  return `${getBlogURL(locale)}/tag/${subpath}`;
};

exports.getTreePlantingURL = (locale) => {
  let subpath = 'where-does-ecosia-plant-trees';
  if (locale === 'de') {
    subpath = 'baumpflanzprojekte';
  } else if (locale === 'fr') {
    subpath = 'arbres-pays';
  }
  return `${getBlogURL(locale)}/tag/${subpath}`;
};

exports.isOfDomain = (string, domain) => new RegExp(`^([a-z0-9-]+\\.)?${domain}`).test(string);
